'use client'

import { Header } from '@common/core/components'
import { DEFAULT_PROFILE_ITEMS } from '@common/core/const'

import { GatewaySelector } from '@/core/components/GatewaySelector/GatewaySelector'
import { useIsLocalGatewayConfigurationMode } from '@/core/hooks/useIsLocalGatewayConfigurationMode'

import styles from '../../Layout.module.scss'

interface LayoutHeaderProps {
  isError: boolean
  isLoading: boolean
  gatewayName: string
  onRefetchGateway: () => Promise<unknown>
  onProfileClick: (item: string) => void
  onMenuToggle: () => void
}

export function LayoutHeader({
  isError,
  isLoading,
  gatewayName,
  onRefetchGateway,
  onProfileClick,
  onMenuToggle,
}: LayoutHeaderProps) {
  const showLocalGatewayConfiguration = useIsLocalGatewayConfigurationMode()
  const showHostedGatewaySelector = !showLocalGatewayConfiguration && !isError && !isLoading

  const gatewaySelector = (
    <GatewaySelector gatewayName={gatewayName} loading={isLoading} onRefetchGateway={onRefetchGateway} />
  )

  if (isError && !showLocalGatewayConfiguration) {
    return (
      <header className="topbar">
        <Header
          profileItems={DEFAULT_PROFILE_ITEMS}
          searchDisabled
          notificationsDisabled
          onProfileClick={onProfileClick}
          onMenuToggle={onMenuToggle}
        />
      </header>
    )
  }

  if (showLocalGatewayConfiguration) {
    return (
      <header className={`topbar ${styles.localTopbar}`}>
        <div className={styles.mobilePortalHeader}>
          <Header
            profileItems={DEFAULT_PROFILE_ITEMS}
            searchDisabled
            feedbackDisabled={!isError}
            notificationsDisabled
            onProfileClick={onProfileClick}
            onMenuToggle={onMenuToggle}
          />
        </div>
        <div className={styles.localGatewaySelectorBar}>{gatewaySelector}</div>
      </header>
    )
  }

  return (
    <header className="topbar">
      <div className={styles.mobilePortalHeader}>
        <Header
          profileItems={DEFAULT_PROFILE_ITEMS}
          searchDisabled
          feedbackDisabled
          notificationsDisabled
          onProfileClick={onProfileClick}
          onMenuToggle={onMenuToggle}
        />
      </div>

      {showHostedGatewaySelector ? <div className={styles.desktopGatewaySelector}>{gatewaySelector}</div> : null}
    </header>
  )
}
